import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { setLocale, SUPPORTED } from '@/i18n/index'
import type { Locale } from '@/i18n/index'

export function useLocale() {
  // useScope: 'global' is required here — vue-i18n 11.1.6+ throws when
  // useI18n() is called from a plain composable (no owning SFC / <i18n>
  // custom block of its own to scope to), which is exactly this case.
  const { locale } = useI18n({ useScope: 'global' })

  const currentLocale = computed(() => locale.value as Locale)

  function switchLocale(loc: Locale): void {
    setLocale(loc)
  }

  return { currentLocale, supportedLocales: SUPPORTED, switchLocale }
}
